import { connect } from 'react-redux';
import ClassCallModal from 'components/ClassCall/ModalWrapper';

const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ClassCallModal);
